import $ from 'jquery';
import InlineDatePicker from './lib/inlineDatePicker';

function initRmaItemSelector() {
  $('#order-return-form table thead input[type=checkbox]').on('click', function() {
    var checked = $(this).prop('checked');
    $('#order-return-form table tbody input[type=checkbox]').each(function(_, checkbox) {
      $(checkbox).prop('checked', checked);
    });
  });
}

function setupCustomerScripts() {
  if ($('body#order-detail')) {
    initRmaItemSelector();
  }
  // Le calendrier est construit à l'ouverture de sa modale : une instance par
  // abonnement, sans dépendre d'un identifiant unique dans le DOM.
  $(document).on('show.bs.modal', '.modal', function() {
    const container = this.querySelector('.inline-datepicker');

    if (!container || container.dataset.datepickerReady) {
      return;
    }

    container.dataset.datepickerReady = '1';
    new InlineDatePicker(container);
  });
}

$(document).ready(setupCustomerScripts);
